<template>
  <div class="adviser-enrolment-wrapper">
    <div class="adviser-enrolment-content">
      <div class="mb-12">
        <h1>Why Wills matter</h1>
        <p>
          <strong>85% of South Africans die without a will,</strong> leaving
          their <strong>families vulnerable</strong> when the unexpected
          happens. As trusted financial advisers,
          <strong>you have the power to change this.</strong>
        </p>
        <p>
          Through the <strong>Old Mutual Will platform</strong>, we're making it
          easier than ever to help clients
          <strong
            >protect their legacy and provide for their loved ones.</strong
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MfcAdviserEnrolmentIntro',
  };
</script>

<style scoped lang="scss">
  .adviser-enrolment-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 80px;
  }

  .adviser-enrolment-content {
    width: 100%;
    max-width: 768px;
    justify-self: center;
    position: relative;
    z-index: 1;
  }

  h1 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 24px;
  }

  p {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
  }
</style>
